import { render } from "./VirtualRealitySection.vue?vue&type=template&id=8c34e78a&scoped=true"
import script from "./VirtualRealitySection.vue?vue&type=script&lang=js"
export * from "./VirtualRealitySection.vue?vue&type=script&lang=js"

import "./VirtualRealitySection.vue?vue&type=style&index=0&id=8c34e78a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c34e78a"]])

export default __exports__